<template>
  <div class="container">
    <div class="head">
      <div class="search">
        <div class="ipt">
          <input placeholder="旅行社名称/业务经营许可证号" />
        </div>
        <div class="search-btn">查询</div>
      </div>
      <div class="cs-sort">
        <div class="by-time">按发起时间排序</div>
        <div class="by-state">投诉状态</div>
      </div>
    </div>

    <div class="list">
      <div class="item">
        <div class="item-head">
          <div class="name">碧辉园大酒店</div>
          <div class="btn" :class="isEvaluate==true?'hg':'dpj'">待评价</div>
        </div>

        <div class="item-cont">
          <div>企业类型：餐饮企业</div>
          <div>统一社会信用代码：201907221534239102277</div>
        </div>

        <div class="score" v-if="isEvaluate==true">
          <div class="term">政府评级分<span>90</span></div>
          <div class="term">专业评价分<span>90</span></div>
        </div>

      </div>
      <div class="item">
        <div class="item-head">
          <div class="name">碧辉园大酒店</div>
          <div class="btn" :class="isEvaluate==false?'hg':'dpj'">合格</div>
        </div>

        <div class="item-cont">
          <div>企业类型：餐饮企业</div>
          <div>统一社会信用代码：201907221534239102277</div>
        </div>

        <div class="score" v-if="isEvaluate==false">
          <div class="term">政府评级分<span>90</span></div>
          <div class="term">专业评价分<span>90</span></div>
        </div>

      </div>
    </div>
    <!-- 没有扣分记录提示 -->
    <div v-if="recordList.length==0" class="noData-bg">
      <nodata :noData="noData"></nodata>
    </div>
    <template v-if="recordList.length>0">
      <deducList :recordList="recordList" @navToDetail="navToDetail"></deducList>
    </template>
  </div>
</template>
<script>
  // import Vue from 'vue';
    import nodata from '../components/nodata';// 没有数据
    import deducList from '../components/deducList';// 扣分列表
    import {} from 'vant';
    // Vue.use(Picker);
    export default {
        components: {
            nodata,
            deducList
        },

        data () {
            return {
                isEvaluate: false, // 是否评价
                noData: {
                    title: '没有投诉记录'
                },
                recordList: []
            }
        },

        computed: {},

        watch: {},

        methods: {
            navTo () {
                this.$router.push({
                    path: '/appraise/scoringList',
                    query: {}
                });
            },
            navToDetail () {
                this.$router.push({
                    path: '/appraise/deductionDetail-no',
                    query: {}
                });
            }
        },

        mounted () {},

        created () {}

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    display: flex;
    flex-direction: column;
    .noData-bg{
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
    }

    .head {
      background: #fff;
      padding: 12px 16px;
      margin-bottom: 24px;
      .search{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .ipt{
          position: relative;
          flex: 1;
          height:36px;
          background:rgba(255,255,255,1);
          border-radius:3px;
          border:1px solid rgba(238,238,238,1);
          input{
            width: 100%;
            height: 100%;
            font-size:14px;
            line-height: 36px;
            padding-left: 35px;
            box-sizing: border-box;
          }
          input::-webkit-input-placeholder{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(153,153,153,1);
          }
        }
        .ipt::before{
          content: '';
          position: absolute;
          left: 12px;
          top: 50%;
          margin-top: -7px;
          width: 15px;
          height: 14px;
          background: url(../../../assets/image/search.png) no-repeat;
          background-size: 15px 14px;
        }
        .search-btn{
          width: 48px;
          text-align: right;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:36px;
        }
      }
      .cs-sort{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 48px 0 30px;
        div{
          position: relative;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(102,102,102,1);
          line-height:12px;
          padding-right: 11px;
        }
        div::after{
          content:'';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 4px;
          background: url(../../../assets/image/jiantou.png) no-repeat;
          background-size: 6px 4px;
        }
      }
    }
    .list{
      padding: 0 12px 16px 12px;
      .item{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-bottom: 24px;
        &-head{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 16px 0 16px;
          .name{
            font-size:14px;
            font-family:PingFangSC-Semibold,PingFang SC;
            font-weight:600;
            color:rgba(42,42,42,1);
          }
          .btn{
            min-width:46px;
            padding: 4px 8px;
            background:rgba(255,140,25,1);
            border-radius:9px;
            text-align: center;
            color: #fff;
          }
          .dpj{
            background:rgba(255,140,25,1);
          }
          .hg{
            background:rgba(54,179,116,1);
          }
        }
        &-cont{
          padding: 16px;
          div{
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:12px;
            margin-bottom: 12px;
          }
          div:last-child{
            margin-bottom: 0;
          }
        }
        .score{
          display: flex;
          height: 45px;
          border-top: solid 1Px #EEEEEE;
          .term{
            position: relative;
            flex:1;
            line-height: 45px;
            text-align: center;
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:#333333;
            span{
              padding-left: 4px;
            }
          }
          .term:first-child::after{
            content:'';
            position: absolute;
            right: 0;
            top: 50%;
            height: 12px;
            transform: translateY(-50%);
            border-right: solid 1Px #999999;
          }
        }
      }
    }
  }
</style>
